export default function HoverFace() {
  return (
    <img
      src={process.env.PUBLIC_URL + "/images/49RecoilspillHover.jpg"}
      alt=""
    />
  );
}
